import { render, staticRenderFns } from "./shopWalletLog.vue?vue&type=template&id=81d1e074&scoped=true&"
import script from "./shopWalletLog.vue?vue&type=script&lang=js&"
export * from "./shopWalletLog.vue?vue&type=script&lang=js&"
import style0 from "./shopWalletLog.vue?vue&type=style&index=0&id=81d1e074&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d1e074",
  null
  
)

export default component.exports